// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"99":"LazyGoogleOneTap","873":"LazyIdentificationForm"}[chunkId] + "." + {"99":"ca9aeb195f1ea935ff1a","873":"ee8590f6ec4745bbfa07"}[chunkId] + ".js";
};